var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M29.386 28H2.616c-.953 0-1.802-.49-2.272-1.311-.463-.809-.458-1.771.013-2.574L13.74 1.288C14.214.482 15.059 0 16 0c.942 0 1.787.482 2.259 1.289l13.385 22.827c.472.804.477 1.766.014 2.574-.47.82-1.32 1.31-2.273 1.31zM2.082 25.127c-.145.247-.064.462-.003.568.053.092.21.305.537.305h26.77c.328 0 .485-.214.538-.306.06-.105.142-.321-.003-.567L16.535 2.3c-.16-.27-.426-.3-.534-.3-.108 0-.375.029-.534.3L2.082 25.127zM16 19.01c-.552 0-1-.447-1-1v-8c0-.552.448-1 1-1s1 .448 1 1v8c0 .553-.448 1-1 1zm0 4c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71 0-.26.11-.521.29-.71.37-.37 1.05-.37 1.42 0 .18.189.29.45.29.71 0 .26-.11.52-.29.71-.19.18-.44.29-.71.29z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0z",
    transform: "translate(0 -2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningWhite);
export default __webpack_public_path__ + "static/media/warning-white.85e08db94e2602e7ee52cb1d31bebeda.svg";
export { ForwardRef as ReactComponent };